import { render } from "./ProfileLayout.vue?vue&type=template&id=2828b8a0&scoped=true"
import script from "./ProfileLayout.vue?vue&type=script&lang=js"
export * from "./ProfileLayout.vue?vue&type=script&lang=js"

import "./ProfileLayout.vue?vue&type=style&index=0&id=2828b8a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2828b8a0"]])

export default __exports__